"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _ETypes = _interopRequireDefault(require("crm_universal/timeline/ETypes"));

var _TimelineEmailContainerAsync = _interopRequireDefault(require("crm_ui/timeline/components/events/email/TimelineEmailContainerAsync"));

var _TimelineConversationAsync = _interopRequireDefault(require("crm_ui/timeline/components/events/conversation/TimelineConversationAsync"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _TimelineCardSkeleton = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineCardSkeleton"));

var _TimelineCardError = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineCardError"));

var _fromJS;

function makeLoadableCard(loader) {
  return (0, _Loadable.default)({
    loader: loader,
    LoadingComponent: _TimelineCardSkeleton.default,
    ErrorComponent: _TimelineCardError.default,
    delay: 0
  });
}

var TimelineCompactEventAsync = makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-compact" */
  'crm_ui/timeline/components/events/TimelineCompactEvent');
});

var _default = (0, _immutable.fromJS)((_fromJS = {}, (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventEngagement, {
  NOTE: makeLoadableCard(function () {
    return import(
    /* webpackChunkName: "card-note" */
    'crm_ui/timeline/components/events/note/TimelineNote');
  }),
  EMAIL: _TimelineEmailContainerAsync.default,
  FORWARDED_EMAIL: _TimelineEmailContainerAsync.default,
  INCOMING_EMAIL: _TimelineEmailContainerAsync.default,
  FEEDBACK_SUBMISSION: makeLoadableCard(function () {
    return import(
    /* webpackChunkName: "card-feedback" */
    'crm_ui/timeline/components/events/feedbackSubmission/TimelineFeedbackSubmissionEvent');
  }),
  TASK: makeLoadableCard(function () {
    return import(
    /* webpackChunkName: "card-task" */
    'crm_ui/timeline/components/events/task/TimelineTask');
  }),
  CALL: makeLoadableCard(function () {
    return import(
    /* webpackChunkName: "card-call" */
    'crm_ui/timeline/components/events/call/TimelineCall');
  }),
  MEETING: makeLoadableCard(function () {
    return import(
    /* webpackChunkName: "card-meeting" */
    'crm_ui/timeline/components/events/meeting/TimelineMeeting');
  }),
  LOGGED_EMAIL: makeLoadableCard(function () {
    return import(
    /* webpackChunkName: "card-log-email" */
    'crm_ui/timeline/components/events/email/logged/TimelineLoggedEmail');
  }),
  LOGGED_MEETING: makeLoadableCard(function () {
    return import(
    /* webpackChunkName: "card-log-meeting" */
    'crm_ui/timeline/components/events/meeting/logged/TimelineLoggedMeeting');
  }),
  CONVERSATION_SESSION: _TimelineConversationAsync.default
}), (0, _defineProperty2.default)(_fromJS, _ETypes.default.dealCreated, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-deal" */
  'crm_ui/timeline/components/events/TimelineDealEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.dealstageChange, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-deal" */
  'crm_ui/timeline/components/events/TimelineDealEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventFeedbackSubmission, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-feedback" */
  'crm_ui/timeline/components/events/TimelineFeedbackSubmissionEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventAdInteraction, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-ads" */
  'crm_ui/timeline/components/events/TimelineAdInteractionEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventAnalytics, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-analytics" */
  'crm_ui/timeline/components/events/TimelineAnalyticEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventAutomation, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-workflow" */
  'crm_ui/timeline/components/events/TimelineWorkflowEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventAutomationPlatform, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-automation" */
  'crm_ui/timeline/components/events/TimelineAutomationPlatformEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventCtaClick, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-cta" */
  'crm_ui/timeline/components/events/TimelineCtaEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventEmailOptOut, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-subscription" */
  'crm_ui/timeline/components/events/TimelineSubscriptionChangeEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventEmailSend, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-marketing-email" */
  'crm_ui/timeline/components/events/email/TimelineMarketingEmail');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventEmailUnbounce, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-unbounce" */
  'crm_ui/timeline/components/events/TimelineEmailUnbounceEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventFormSubmission, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-form" */
  'crm_ui/timeline/components/events/formSubmission/TimelineFormSubmissionEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventIntegrations, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-integrations" */
  'crm_ui/timeline/components/events/thirdParty/integrations/TimelineIntegrationsEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventLifecycleStage, TimelineCompactEventAsync), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventListMembership, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-lists" */
  'crm_ui/timeline/components/events/TimelineListMembershipEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventMerge, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-merge" */
  'crm_ui/timeline/components/events/TimelineMergeEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventPageView, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-page-view" */
  'crm_ui/timeline/components/events/TimelinePageViewRollupEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventPresentation, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-content" */
  'crm_ui/timeline/components/events/TimelineContentEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventPrivacyConsent, TimelineCompactEventAsync), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventProductQuote, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-quote" */
  'crm_ui/timeline/components/events/TimelineProductQuoteEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventSalesforceSync, TimelineCompactEventAsync), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventSequence, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-sequence" */
  'crm_ui/timeline/components/events/sequences/TimelineSequencesEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventSidekick, TimelineCompactEventAsync), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventSurveyMonkeySurvey, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-survey" */
  'crm_ui/timeline/components/events/thirdParty/TimelineSurveyMonkeyEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventTicketCreated, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-tickets" */
  'crm_ui/timeline/components/events/TimelineTicketEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventTicketStageChange, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-tickets" */
  'crm_ui/timeline/components/events/TimelineTicketEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventTwitterMatch, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-twitter" */
  'crm_ui/timeline/components/events/thirdParty/TimelineTwitterEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventWebinarAttendance, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-webinar" */
  'crm_ui/timeline/components/events/thirdParty/TimelineWebinarAttendanceEvent');
})), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventWebinarRegistration, TimelineCompactEventAsync), (0, _defineProperty2.default)(_fromJS, _ETypes.default.eventWistia, makeLoadableCard(function () {
  return import(
  /* webpackChunkName: "card-wistia" */
  'crm_ui/timeline/components/events/thirdParty/TimelineWistiaEvent');
})), _fromJS));

exports.default = _default;
module.exports = exports.default;